import { lightOrDark, whiteOrBlackTextColor } from 'helpers/StyleUtils';
import useWebsiteBuilder, { CollectDataInputType, WebsiteBuilderContent, WebsiteBuilderStyle } from 'Hooks/useWebsiteBuilder';
import { capitalizeFirstLetter, makeKey, styx } from 'modules/Utils';
import { CSSProperties, Fragment, useState } from 'react';

interface CollectDataPreviewContentProps {
    contentIndex: number;
    websiteContent: WebsiteBuilderContent[];
    websiteStyle: WebsiteBuilderStyle;
    style?: CSSProperties;
    onClickContentBlock?: (index: number) => void;
}

const CollectDataPreviewContent = ({
    contentIndex,
    websiteContent: websiteContentProp,
    websiteStyle: websiteStyleProp,
    style: styleProp,
    onClickContentBlock,
}: CollectDataPreviewContentProps) => {
    const {
        websiteContent: websiteContentState,
        websiteStyle: websiteStyleState,
    } = useWebsiteBuilder();

    const websiteContent = websiteContentProp || websiteContentState;
    const websiteStyle = websiteStyleProp || websiteStyleState;

    const contentBackgroundColor = websiteContent[contentIndex].contentBackgroundColor;
    const isContentBackgroundColorEnabled = websiteContent[contentIndex].isContentBackgroundColorEnabled;

    const contentSecondaryColor = websiteContent[contentIndex].contentSecondaryColor;
    const isContentSecondaryColorEnabled = websiteContent[contentIndex].isContentSecondaryColorEnabled;

    const contentTextColor = websiteContent[contentIndex].contentTextColor;
    const isContentTextColorEnabled = websiteContent[contentIndex].isContentTextColorEnabled;

    const contentTextSecondaryColor = websiteContent[contentIndex].contentTextSecondaryColor;
    const isContentTextSecondaryColorEnabled = websiteContent[contentIndex].isContentTextSecondaryColorEnabled;

    const [isEmail, setIsEmail] = useState<boolean>(true);

    const {
        textColor: OLD,
        backgroundColor: backgroundColorWebsiteStyle,
        secondaryColor: secondaryColorWebsiteStyle,
        fontFamily,
    } = websiteStyle;

    const backgroundColor = isContentBackgroundColorEnabled ?
        (contentBackgroundColor || backgroundColorWebsiteStyle || 'transparent') :
        (backgroundColorWebsiteStyle || 'transparent');

    const secondaryColor = isContentSecondaryColorEnabled ?
        (contentSecondaryColor || secondaryColorWebsiteStyle || 'transparent') :
        (secondaryColorWebsiteStyle || 'transparent');

    const textColor = isContentTextColorEnabled ? contentTextColor : whiteOrBlackTextColor(backgroundColor);
    const secondaryTextColor = isContentTextSecondaryColorEnabled ? contentTextSecondaryColor : whiteOrBlackTextColor(secondaryColor);

    const collectDataContent = websiteContent[contentIndex].collectDataContent;
    const isBothEmailPhone = collectDataContent?.isBothEmailPhone || false;

    const isSecondaryColorLocalEnabled = websiteContent[contentIndex].isContentSecondaryColorEnabled;
    const secondaryColorLocal = isSecondaryColorLocalEnabled ? websiteContent[contentIndex].contentSecondaryColor || '#FFFFFF' : secondaryColor;

    const renderEmailPhoneToggle = () => {
        return (
            <div
                className="contactFormEmailPhoneButtons"
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    border: `1px solid ${secondaryColorLocal}`,
                    borderRadius: 8,
                    width: 'fit-content',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}
            >
                <div
                    className="contactFormEmailPhoneButton"
                    style={styx(
                        sty.contactFormEmailPhoneButton,
                        {
                            color: isEmail ? secondaryTextColor : textColor,
                            backgroundColor: isEmail ? secondaryColorLocal : 'transparent',
                        }
                    )}
                    onClick={() => setIsEmail(true)}
                >
                    Email
                </div>
                <div
                    className="contactFormEmailPhoneButton"
                    style={styx(
                        sty.contactFormEmailPhoneButton,
                        {
                            color: isEmail ? textColor : secondaryTextColor,
                            backgroundColor: isEmail ? 'transparent' : secondaryColorLocal,
                        }
                    )}
                    onClick={() => setIsEmail(false)}
                >
                    Phone
                </div>
            </div>
        )
    }

    return (
        <div
            className="contactFormPreviewContentComponent"
            style={styx(
                sty.contactFormPreviewContentComponent,
                styleProp,
            )}
            onClick={() => onClickContentBlock?.(contentIndex)}
        >
            {!isBothEmailPhone && renderEmailPhoneToggle()}

            {collectDataContent?.info.map((currentInfo, index) => {
                const isEmailPhoneType = currentInfo.type === CollectDataInputType.EMAIL_PHONE;
                let title = currentInfo.title || capitalizeFirstLetter(currentInfo.type);
                let placeholder = currentInfo.placeholder || `Enter ${currentInfo.type}`;
                const {
                    isRequired,
                } = currentInfo;

                let titlePhone = 'Phone';
                let placeholderPhone = 'Enter your phone number';

                if (isEmailPhoneType) {
                    title = 'Email';
                    placeholder = 'Enter your email';

                    if (!isBothEmailPhone && !isEmail) {
                        title = 'Phone';
                        placeholder = 'Enter your phone number';
                    }
                }

                return (
                    <Fragment key={makeKey(currentInfo.title, index, contentIndex)}>
                        <div
                            className="contactFormPreviewContentItem"
                            style={styx(
                                sty.contactFormPreviewContentItem,
                                {
                                    color: textColor,
                                }
                            )}
                        >
                            {collectDataContent?.isShowTitles &&
                                <div
                                    className="contactFormPreviewContentLabel"
                                    style={sty.contactFormPreviewContentLabel}
                                >
                                    {title} {isRequired && "*"}
                                </div>
                            }
                            <div
                                className="contactFormPreviewContentInput"
                                style={styx(
                                    sty.contactFormPreviewContentInput,
                                    {
                                        borderColor: `${textColor}30`,
                                        color: `${textColor}70`,
                                        fontFamily,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }
                                )}
                            >
                                {placeholder}
                            </div>
                        </div>
                        {isEmailPhoneType && isBothEmailPhone &&
                            <div
                                className="contactFormPreviewContentItem"
                                style={styx(
                                    sty.contactFormPreviewContentItem,
                                    {
                                        color: textColor,
                                    }
                                )}
                            >
                                {collectDataContent?.isShowTitles &&
                                    <div
                                        className="contactFormPreviewContentLabel"
                                        style={sty.contactFormPreviewContentLabel}
                                    >
                                        {titlePhone} {isRequired && "*"}
                                    </div>
                                }
                                <div
                                    className="contactFormPreviewContentInput"
                                    style={styx(
                                        sty.contactFormPreviewContentInput,
                                        {
                                            borderColor: `${textColor}30`,
                                            color: `${textColor}70`,
                                            fontFamily,
                                        }
                                    )}
                                >
                                    {placeholderPhone}
                                </div>
                            </div>
                        }
                    </Fragment>
                )
            })}
            <button
                className="contactFormPreviewContentButton"
                style={styx(
                    sty.contactFormPreviewContentButton,
                    {
                        color: secondaryTextColor,
                        backgroundColor: secondaryColorLocal,
                        fontSize: 16,
                        fontFamily
                    }
                )}
                onClick={() => { }}
            >
                {collectDataContent?.buttonText || 'Subscribe'}
            </button>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    contactFormPreviewContentComponent: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingLeft: 16,
        paddingRight: 16,
        gap: 8,
    },
    contactFormPreviewContentItem: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    contactFormPreviewContentLabel: {
        fontSize: 12,
        opacity: 0.5,
        marginLeft: 8,
        marginBottom: 2,
    },
    contactFormPreviewContentInput: {
        fontSize: 14,
        borderRadius: 8,
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 8,
        paddingRight: 8,
        borderWidth: 1,
        borderStyle: 'solid',
    },
    contactFormPreviewContentButton: {
        fontSize: 16,
        borderRadius: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        border: 'none',
        cursor: 'pointer',
        width: 'fit-content',
        marginTop: 8,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    contactFormEmailPhoneButton: {
        borderRadius: 7,
        padding: 8,
        cursor: 'pointer',
        width: 90,
        textAlign: 'center',
    }
}

export default CollectDataPreviewContent;